/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaseProposal } from './CaseProposal';
import {
    CaseProposalFromJSON,
    CaseProposalFromJSONTyped,
    CaseProposalToJSON,
    CaseProposalToJSONTyped,
} from './CaseProposal';
import type { CaseAccountInformationType } from './CaseAccountInformationType';
import {
    CaseAccountInformationTypeFromJSON,
    CaseAccountInformationTypeFromJSONTyped,
    CaseAccountInformationTypeToJSON,
    CaseAccountInformationTypeToJSONTyped,
} from './CaseAccountInformationType';
import type { CaseStatusDetail } from './CaseStatusDetail';
import {
    CaseStatusDetailFromJSON,
    CaseStatusDetailFromJSONTyped,
    CaseStatusDetailToJSON,
    CaseStatusDetailToJSONTyped,
} from './CaseStatusDetail';

/**
 * 
 * @export
 * @interface CaseServiceDetailsResponse
 */
export interface CaseServiceDetailsResponse {
    /**
     * 
     * @type {string}
     * @memberof CaseServiceDetailsResponse
     */
    placeholderName?: string;
    /**
     * 
     * @type {CaseStatusDetail}
     * @memberof CaseServiceDetailsResponse
     */
    status?: CaseStatusDetail;
    /**
     * 
     * @type {CaseAccountInformationType}
     * @memberof CaseServiceDetailsResponse
     */
    accountInformation?: CaseAccountInformationType;
    /**
     * 
     * @type {Array<CaseProposal>}
     * @memberof CaseServiceDetailsResponse
     */
    proposals?: Array<CaseProposal>;
}

/**
 * Check if a given object implements the CaseServiceDetailsResponse interface.
 */
export function instanceOfCaseServiceDetailsResponse(value: object): value is CaseServiceDetailsResponse {
    return true;
}

export function CaseServiceDetailsResponseFromJSON(json: any): CaseServiceDetailsResponse {
    return CaseServiceDetailsResponseFromJSONTyped(json, false);
}

export function CaseServiceDetailsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseServiceDetailsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'placeholderName': json['placeholderName'] == null ? undefined : json['placeholderName'],
        'status': json['status'] == null ? undefined : CaseStatusDetailFromJSON(json['status']),
        'accountInformation': json['accountInformation'] == null ? undefined : CaseAccountInformationTypeFromJSON(json['accountInformation']),
        'proposals': json['proposals'] == null ? undefined : ((json['proposals'] as Array<any>).map(CaseProposalFromJSON)),
    };
}

export function CaseServiceDetailsResponseToJSON(json: any): CaseServiceDetailsResponse {
    return CaseServiceDetailsResponseToJSONTyped(json, false);
}

export function CaseServiceDetailsResponseToJSONTyped(value?: CaseServiceDetailsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'placeholderName': value['placeholderName'],
        'status': CaseStatusDetailToJSON(value['status']),
        'accountInformation': CaseAccountInformationTypeToJSON(value['accountInformation']),
        'proposals': value['proposals'] == null ? undefined : ((value['proposals'] as Array<any>).map(CaseProposalToJSON)),
    };
}

